import SelectOption from '@trilogy-ds/react/lib/components/select/option/SelectOption';
/**
 * Select Option Component
 * @param children {React.ReactNode}
 * @param label {string} option name
 * @param disabled {boolean} disable option
 * @param onClick {function} onclick function
 * @param iconName {IconName | IconNameValues} icon
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal CSS Classes
 * @param testId {string} id for testing
 * @param iconName {IconName | IconNameValues} icon
 * @param id {string} Select option custom id
 * @param value {string} Select option value
 */
export default SelectOption;
//# sourceMappingURL=SelectOption.js.map